module.exports = __webpack_public_path__ + "static/media/SM-MT-TRIAL2.044d0d9b.mp3";